<template>
  <div class="price-rules">
    <el-row :gutter="10">
      <el-col :span="4"><div class="label" v-if="priceRule.type && priceRule.platFormPriceConfig">{{priceRule.platFormPriceConfig[priceRule.type]}}配置：</div></el-col>
      <el-col :span="16"><div class="content">{{ priceRule.priceConfText }}</div></el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="4"><div class="label">铺货价格递增：</div></el-col>
      <el-col :span="6"><div class="content">{{ priceRule.incr ? '是' : '否' }}</div></el-col>
      <template v-if="priceRule.incr">
        <el-col :span="4"><div class="label">递增金额：</div></el-col>
        <el-col :span="6"><div class="content">{{ priceRule.incr }}</div></el-col>
      </template>
    </el-row>
    <el-row :gutter="10" v-if="isDistributor && priceRule.supplyFreight">
      <el-col :span="4"><div class="label">附加供销运费</div></el-col>
      <el-col :span="16"><div class="content">{{ priceRule.supplyFreight }}</div></el-col>
    </el-row>
    <div v-if="priceRule.incr" style="color: red">配置铺货价格递增后可能会发生破价，导致商品发布失败，具体以平台后台信息及铺货日志为准</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  props: {
    priceRule: Object,
  },
  data() {
    return {};
  },
  computed:{
    ...mapGetters(['isDistributor']),
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.price-rules {
  font-size: 12px;
  .el-row {
    margin-bottom: 10px;
  }
  .label {
    text-align: right;
  }
  .content {
    font-weight: 700;
  }
}
</style>
